const BASE_SERVER_PATH = process.env.VUE_APP_MANAGE_BASE
const VUE_APP_MANAGE_DRIVER_API = process.env.VUE_APP_MANAGE_DRIVER_API
const VUE_APP_MANAGE_DISCOUNT_API = process.env.VUE_APP_MANAGE_DISCOUNT_API
const VUE_APP_MANAGE_DISCOUNT_GET_API = process.env.VUE_APP_MANAGE_DISCOUNT_GET_API
const VUE_APP_MANAGE_SERVICE = process.env.VUE_APP_MANAGE_SERVICE
const VUE_APP_MANAGE_API = process.env.VUE_APP_MANAGE_API
export default {
  BASE_SERVER_MANAGE_PATH: BASE_SERVER_PATH,
  COMPLAINT_SERVER: BASE_SERVER_PATH,
  COMPLAINT_SERVER_CC: BASE_SERVER_PATH,
  VUE_APP_MANAGE_DRIVER_API: VUE_APP_MANAGE_DRIVER_API,
  VUE_APP_MANAGE_DISCOUNT_API: VUE_APP_MANAGE_DISCOUNT_API,
  VUE_APP_MANAGE_DISCOUNT_GET_API: VUE_APP_MANAGE_DISCOUNT_GET_API,
  VUE_APP_MANAGE_API: VUE_APP_MANAGE_API,
  VUE_APP_MANAGE_SERVICE: VUE_APP_MANAGE_SERVICE
}
